import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PlatformFoodtalks"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M19.6443 5.29303C18.2807 3.92947 16.5434 3.00087 14.6521 2.62466C12.7608 2.24846 10.8004 2.44154 9.01884 3.1795C7.23726 3.91745 5.71451 5.16713 4.64317 6.77051C3.57183 8.37389 3 10.259 3 12.1873C3 14.1157 3.57183 16.0008 4.64317 17.6041C5.71452 19.2075 7.23726 20.4572 9.01884 21.1951C10.8004 21.9331 12.7608 22.1262 14.6521 21.75C16.5434 21.3738 18.2807 20.4452 19.6443 19.0816L12.75 12.1873L19.6443 5.29303Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PlatformFoodtalks.vue"]]);
